export default {
  studySearchSummary: 'search-studies-result.xlsx',
  studySearchFragrances: 'search-fragrances-result.xlsx',
  analyticsMetrics: 'fragrance_metrics.xlsx',
  analyticsPerformance: 'fragrance_performance.xlsx',
  analyticsTendencies: 'fragrance_tendencies.xlsx',
  analyticsTopAttributes: 'fragrance_attributes.xlsx',
  fragranceProfile: 'fragrance_profile.xlsx'
}
